import { isEqual } from 'lodash-es'
import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators'

import { queueMap } from 'src/services/data/utils'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { TOP_LEVEL_FILTERS } from '../../../components/matched-offers/matched-offers-list/matched_offers-list.filters'
import {
  loadMatchedOffersFilters, loadMatchedOffersFiltersFailure, loadMatchedOffersFiltersSuccess,
  loadMatchedOffersViews, loadMatchedOffersViewsFailure, loadMatchedOffersViewsSuccess
} from './matched-offers-view.actions'
import { prepareMatchedOffersPayload, prepareFiltersPayload } from './matched-offers-view-filters.utils'
import { MatchedOffersElasticSearchService } from '../../../components/matched-offers/matched-offers-elastic.service'


@Injectable()
export class MatchedOffersViewEffects {
  private actions$ = inject(Actions)
  private elastic = inject(MatchedOffersElasticSearchService)
  private toaster = inject(ToasterService)


  loadMatchedOffersViews$ = createEffect(() => this.actions$.pipe(
    ofType(loadMatchedOffersViews),
    map(action => ({
      action,
      payload: prepareMatchedOffersPayload(action.filters, action.page),
    })),
    queueMap(({action, payload}) => {
      return this.elastic.search({ ...payload }).pipe(
        map(r => loadMatchedOffersViewsSuccess({
          tableKey: action.tableKey,
          total: r.total,
          matchedOffers: r.data,
          payload,
          totals: {}
        })),
        catchAndLog(this.toaster, 'Unable to fetch MatchedOffers', loadMatchedOffersViewsFailure
      ))})))


  loadMatchedOffersFilters$ = createEffect(() => this.actions$.pipe(
    ofType(loadMatchedOffersFilters),
    map(action => ({
      tableKey: action.tableKey,
      payload: prepareFiltersPayload(action.filters, TOP_LEVEL_FILTERS[action.tableKey]),
    })),
    distinctUntilChanged(isEqual),
    switchMap(({tableKey, payload}) => this.elastic.filters(payload).pipe(
      map(result => loadMatchedOffersFiltersSuccess({ tableKey, result })),
      catchAndLog(this.toaster, 'Unable to fetch MatchedOffers', loadMatchedOffersFiltersFailure)
    ))))
}
